import { useAuthContext } from "providers/Auth";
import { Links } from "./constants";

export const shouldShowGlobalLink = (
  name: string,
  type: ReturnType<typeof useAuthContext>["type"]
) => {
  // Native chat lives in the Inbox and ships to BoomScreen-only partners too, so
  // surface the Inbox for them even without the BoomCRM communication features.
  if (name === Links.INBOX)
    return (
      (type.isBoomCRM && (type.isCommunication || type.isCommunicationSms)) ||
      (type.isNativeChat && (type.isBoomScreen || type.isBoomCRM))
    );
  if (name === Links.CONTACTS) return type.isBoomCRM;
  if (name === Links.TASKS) return type.isBoomCRM && type.isTasks;
  // Analytics is always reachable; the crm_analytics flag only gates the
  // BoomCRM subtab inside the view.
  if (name === Links.PHONE_NUMBERS)
    return type.isBoomCRM && type.isProvisionedPhoneNumber;

  if (
    (type.isPropertyManager || !type.isBoomScreen) &&
    name === Links.PROPERTY_GROUPS
  )
    return false;

  if (
    (!type.isBoomCRM || !type.isBoomScreen || !type.isCrmFeatureWorkflows) &&
    name === Links.WORKFLOWS
  )
    return false;

  return true;
};

export const shouldShowReportingLinks = (
  name: string,
  type: ReturnType<typeof useAuthContext>["type"],
  partner: ReturnType<typeof useAuthContext>["partner"],
  pms: ReturnType<typeof useAuthContext>["pms"]
) => {
  const isAppfolioWithoutSupergood =
    pms.isAppfolio && !partner?.appfolio_supergood_enabled;

  const isBlockedRenter =
    name === Links.RENTERS &&
    (!type.isPMS ||
      (type.isBoomScreen && !type.isRentReporting) ||
      isAppfolioWithoutSupergood);

  return !isBlockedRenter;
};
